<template>
  <gs-named-modal class="gs-refresh-controls gs-aff-modal" name="affiliate-links-modal"
    :title="$t('frontend_affiliate_links')" width="1120px" max-width="1120px" @opened="affiliateLinksTab = 'aff_links'">
    <affiliate-workspace :sections="affiliateLinksTabs" :current="affiliateLinksTab" label="Affiliate link sections"
      @select="handleAffiliateLinksTabChange">
      <button slot="navigation" type="button" @click="goToPromoTools">
        {{ $t('frontend_affiliate_promos_promo_tools') }}
        <small>Swipes, banners, and other resources</small>
      </button>
      <header class="gs-aff-panel-head">
        <div><h2>{{ currentSectionTitle }}</h2><p>Copy a tracked link to share with your audience.</p></div>
        <gs-button v-if="affiliateLinksTab === 'custom_landing_pages'" variant="primary" size="sm" @click="openCreate()">
          <gs-icon name="plus" size="16" /> {{ $t('frontend_groovesell_add_new_landing_page') }}
        </gs-button>
        <span v-else class="gs-aff-count">{{ visibleLinks.length }} {{ visibleLinks.length === 1 ? 'link' : 'links' }}</span>
      </header>
      <div v-if="visibleLinks.length" class="gs-aff-link-list">
        <article v-for="(link, index) in visibleLinks" :key="link.id || index" class="gs-aff-link-card">
          <h3>{{ link.name }}</h3>
          <div class="gs-aff-link-card__row">
            <code class="gs-aff-link-card__url" tabindex="0" :aria-label="link.name + ' URL'">{{ linkUrl(link) }}</code>
            <div class="gs-aff-link-card__actions">
              <gs-button variant="outline" size="sm" :aria-label="'Copy ' + link.name" @click="copyLink(link)">
                <gs-icon name="copy" size="16" /> {{ $t('frontend_copy') }}
              </gs-button>
              <template v-if="affiliateLinksTab === 'custom_landing_pages'">
                <gs-button variant="ghost" size="icon" :title="$t('frontend_groovesell_edit')" :aria-label="'Edit ' + link.name" @click="openEditCustomLandingPage(link.id)">
                  <gs-icon name="edit" size="16" />
                </gs-button>
                <gs-button variant="ghost" size="icon" class="is-destructive" :title="$t('frontend_groovesell_delete')" :aria-label="'Delete ' + link.name" @click="deleteLandingPageUrl(link.id)">
                  <gs-icon name="trash" size="16" />
                </gs-button>
              </template>
            </div>
          </div>
        </article>
      </div>
      <p v-else class="gs-aff-empty">{{ affiliateLinksTab === 'custom_landing_pages' ? $t('frontend_affiliate_custom_landing_page_url_to_fetch') : $t('frontend_affiliate_promos_unable_to_fetch') }}</p>
    </affiliate-workspace>
    <div slot="footer" class="gs-aff-footer">
      <gs-button variant="outline" @click="$root.$emit('modal-close', 'affiliate-links-modal')">{{ $t('frontend_close') }}</gs-button>
    </div>
  </gs-named-modal>
</template>
<script>
import AffiliateWorkspace from '../../components/AffiliateWorkspace.vue';
import { copyAsset } from '@/components/promotools/copyAsset';
import Notify from '@groovepages/gd-ui-kit/notify';

export default {
    components: {
        AffiliateWorkspace,
    },
    props: {
        affiliateLinks: {
            required: true,
        },
        openCreate: {
            required: true,
            type: Function,
        },
        openEditCustomLandingPage: {
            required: true,
            type: Function,
        },
        deleteLandingPageUrl: {
            required: true,
            type: Function,
        },
        selectedFunnelId: {

        },
    },
    data() {
        return {
            affiliateLinksTab: 'aff_links',

        }
    },

    computed: {
        affiliateLinksTabs() {
            const secondTierLinksLength = this.affiliateLinks.filter((link) => {
                return link.type === 'second_tier';
            }).length;

            if (secondTierLinksLength > 0) {
                return [
                    { title: this.$t('frontend_affiliate_link_tabs_afiliate_links'), value: 'aff_links' },
                    { title: this.$t('frontend_resource_my_jv_broker_links'), value: 'jv_broker_links' },
                    { title: this.$t('frontend_product_step9_custom_landing'), value: 'custom_landing_pages' },
                ];
            }

            return [
                { title: this.$t('frontend_affiliate_link_tabs_afiliate_links'), value: 'aff_links' },
                { title: this.$t('frontend_product_step9_custom_landing'), value: 'custom_landing_pages' },
            ];
        },
        currentSectionTitle() {
            const section = this.affiliateLinksTabs.find(item => item.value === this.affiliateLinksTab);
            return section ? section.title : '';
        },
        visibleLinks() {
            if (this.affiliateLinksTab === 'jv_broker_links') return this.jvBrokerLinks;
            if (this.affiliateLinksTab === 'custom_landing_pages') return this.customLandingPageLinks;
            return this.directAffiliateLinks;
        },
        directAffiliateLinks() {
            return this.affiliateLinks.filter((link) => {
                return link.type === 'affiliate';
            });
        },
        jvBrokerLinks() {
            return this.affiliateLinks.filter((link) => {
                return link.type === 'second_tier';
            });
        },
        customLandingPageLinks() {
            return this.affiliateLinks.filter((link) => {
                return link.type === 'custom_land_page';
            });
        },

    },
    methods: {

        handleAffiliateLinksTabChange(tab) {
            this.affiliateLinksTab = tab;
        },
        goToPromoTools() {
            this.$router.push({
                name: 'promos_dashboard',
                params: { id: this.selectedFunnelId },
            });
        },
        linkUrl(link) {
            return link.type === 'custom_land_page' ? link.landing_page_url : link.link;
        },
        async copyLink(link) {
            try {
                await copyAsset({ text: this.linkUrl(link) }, text => this.$copyText(text));
                this.onCopy();
            } catch (error) {
                this.onError();
            }
        },
        onCopy() {
            Notify.success(this.$t('frontend_aff_link_copied'));
        },

        onError() {
            Notify.fail(this.$t('frontend_aff_link_unable_copy'));
        },
    }
}

</script>
